import React, { Component } from "react";
import { connect } from "react-redux";
import { ToastContainer, toast, Flip } from "react-toastify";
import { createPickTrialDate, createServiceDate, createUserCategory, userBooking } from "./../../actions/index";
import "react-datepicker/dist/react-datepicker.css";
import "react-toastify/dist/ReactToastify.css";
import { ValidatorForm } from "react-material-ui-form-validator";
import { toastConfig } from "../Custom/ToastConfig";
import { TimePickJson } from "./TimePickJson";

const FA = require("react-fontawesome");
Date.prototype.addHours = function (h) {
  this.setHours(this.getHours() + h);
  return this;
};

export class PickServiceTime extends Component {
  constructor(props) {
    super(props);
    this.state = {
      typeOfservice: props.service.services ? props.service.services : null,
      service_time: props.user.service_time,
      trial_time: props.user.trial_time,
      localtimestochild: props.time,
      user_category: props.user.user_category,
      trial_date: props.user.trial_date,
      temp_date: props.user.trial_date
    };
  }

  back = e => {
    e.preventDefault();
    this.props.prevStep();
  };

  // FIXED: Proper date formatting to ISO 8601
  formatDateToISO = (dateStr) => {
    if (!dateStr) return '';
    
    // If already in YYYY-MM-DD format, return as is
    if (/^\d{4}-\d{2}-\d{2}/.test(dateStr)) {
      return dateStr;
    }
    
    // Handle MM-DD-YYYY format (like "11-08-2025")
    if (dateStr.includes('-')) {
      const parts = dateStr.split('-');
      if (parts.length === 3) {
        const [month, day, year] = parts;
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
      }
    }
    
    // Handle MM/DD/YYYY format
    if (dateStr.includes('/')) {
      const parts = dateStr.split('/');
      if (parts.length === 3) {
        const [month, day, year] = parts;
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
      }
    }
    
    return dateStr; // Return original if format is unknown
  };

  handleSubmit = e => {
    e.preventDefault();
    let self = this.state;
    
    // Convert trial_date to ISO 8601 format
    const trialDateISO = this.formatDateToISO(self.trial_date);
    
    console.log("🟢 Original trial_date:", self.trial_date);
    console.log("🟢 Formatted trial_date (ISO):", trialDateISO);

    if (this.state.service_time !== undefined) {
      this.props.onAddPost(
        self.service_time, 
        this.props.service.services, 
        trialDateISO, // Pass the ISO formatted date
        self.user_category, 
        self.trial_time
      );
      this.props.nextStep();
    } else {
      toast("Please input all the required data !!", toastConfig);
    }
  };

  handleInputChange = e => {
    this.setState({
      [e.target.name]: e.target.value
    });
  };

  render() {
    let temp = this.state.startDate;
    var tempDate = new Date();
    var todaytime = tempDate.getHours();

    // Generate 3 dates: Tomorrow, Day After Tomorrow, and 3rd Day
    var dates = [];
    var weekday = new Array(7);
    weekday[0] = "Sunday";
    weekday[1] = "Monday";
    weekday[2] = "Tuesday";
    weekday[3] = "Wednesday";
    weekday[4] = "Thursday";
    weekday[5] = "Friday";
    weekday[6] = "Saturday";

    for (let i = 1; i <= 3; i++) {
      var futureDate = new Date(new Date().valueOf() + 1000 * 3600 * 24 * i);
      var dateStr =
        (futureDate.getMonth() + 1) +
        "-" +
        futureDate.getDate() +
        "-" +
        futureDate.getFullYear() +
        " ";
      var dayName = weekday[futureDate.getDay()];
      
      dates.push({
        id: i,
        value: dateStr,
        label: i === 1 ? "Tomorrow" : i === 2 ? dayName : dayName,
        display: i === 1 ? "Tomorrow" : i === 2 ? dayName : dayName
      });
    }

    return (
      <div>
        <ValidatorForm onSubmit={this.handleSubmit}>
          <div className="input">
            <div className="form-group">
              <strong className="book_heading" style={{ color: "#E9C589 !important", fontFamily: "Roboto !importat" }}>
                Preferred Training Time
              </strong>

              <select
                className="form-control dropdown "
                id="service_time"
                name="service_time"
                onChange={this.handleInputChange}
                value={this.state.service_time}
              >
                <option value="" selected="selected" disabled="disabled">
                  -- select one --
                </option>

                <option value="06:00-07:00AM">06:00-07:00AM</option>
                <option value="07:00-08:00AM">07:00-08:00AM</option>
                <option value="08:00-09:00AM">08:00-09:00AM</option>
                <option value="09:00-10:00AM">09:00-10:00AM</option>
                <option value="10:00-11:00AM">10:00-11:00AM</option>
                <option value="11:00-12:00AM">11:00-12:00AM</option>
                <option value="12:00-01:00PM">12:00-01:00PM</option>
                <option value="01:00-02:00PM">01:00-02:00PM</option>
                <option value="02:00-03:00PM">02:00-03:00PM</option>
                <option value="03:00-04:00PM">03:00-04:00PM</option>
                <option value="04:00-05:00PM">04:00-05:00PM</option>
                <option value="05:00-06:00PM">05:00-06:00PM</option>
                <option value="06:00-07:00PM">06:00-07:00PM</option>
                <option value="07:00-08:00PM">07:00-08:00PM</option>
                <option value="08:00-09:00PM">08:00-09:00PM</option>
                <option value="09:00-10:00PM">09:00-10:00PM</option>
              </select>
            </div>
          </div>
          <div>
            <div className="input">
              <div className="form-group">
                <strong className="book_heading" style={{ color: "#E9C589 !important", fontFamily: "Roboto !importat" }}>Training Needed for</strong>
                <div
                  class="container-row book_session_radio user_category_column"
                  style={{ flexWrap: "wrap" }}
                >
                  <div class="radio ">
                    <input
                      id="radio-1"
                      name="user_category"
                      type="radio"
                      value="Male"
                      checked={this.state.user_category === "Male"}
                      onChange={this.handleInputChange}
                      className={
                        this.state.user_category === "Male" ? "Male" : null
                      }
                    />
                    <label for="radio-1" className="book_radio">
                      Male
                    </label>
                  </div>
                  <div className="radio">
                    <input
                      id="radio-2"
                      name="user_category"
                      type="radio"
                      value="Female"
                      checked={this.state.user_category === "Female"}
                      onChange={this.handleInputChange}
                    />
                    <label for="radio-2" className="book_radio">
                      Female
                    </label>
                  </div>
                  <div className="radio">
                    <input
                      id="radio-3"
                      name="user_category"
                      type="radio"
                      value="Couple"
                      checked={this.state.user_category === "Couple"}
                      onChange={this.handleInputChange}
                    />
                    <label for="radio-3" className="book_radio">
                      Couple
                    </label>
                  </div>
                  <div className="radio">
                    <input
                      id="radio-4"
                      name="user_category"
                      type="radio"
                      value="Group"
                      checked={this.state.user_category === "Group"}
                      onChange={this.handleInputChange}
                      validators={["required"]}
                      errorMessages={["Service cannot be empty"]}
                    />
                    <label for="radio-4" className="book_radio">
                      Group
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="input">
            <div className="form-group">
              <strong className="book_heading" style={{ color: "#E9C589 !important", fontFamily: "Roboto !importat" }}>Select Trial Date</strong>
              <div
                class="container-row book_session_radio user_category_column"
                style={{ flexWrap: "wrap" }}
              >
                {dates.map((date, index) => (
                  <div className="radio" key={date.id}>
                    <input
                      id={`radio-${5 + index}`}
                      name="trial_date"
                      type="radio"
                      value={date.value}
                      checked={this.state.trial_date === date.value}
                      onChange={this.handleInputChange}
                    />
                    <label for={`radio-${5 + index}`} className="book_radio">
                      {date.display}
                    </label>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="input">
            <div className="form-group">
              <strong className="book_heading" style={{ color: "#E9C589 !important", fontFamily: "Roboto !importat" }}>
                Trail Session Time
              </strong>

              <select
                className="form-control dropdown "
                id="trial_time"
                name="trial_time"
                onChange={this.handleInputChange}
                value={this.state.trial_time}
              >
                <option value="" selected="selected" disabled="disabled">
                  -- select one --
                </option>

                <option value="06:00-07:00AM">06:00-07:00AM</option>
                <option value="07:00-08:00AM">07:00-08:00AM</option>
                <option value="08:00-09:00AM">08:00-09:00AM</option>
                <option value="09:00-10:00AM">09:00-10:00AM</option>
                <option value="10:00-11:00AM">10:00-11:00AM</option>
                <option value="11:00-12:00AM">11:00-12:00AM</option>
                <option value="12:00-01:00PM">12:00-01:00PM</option>
                <option value="01:00-02:00PM">01:00-02:00PM</option>
                <option value="02:00-03:00PM">02:00-03:00PM</option>
                <option value="03:00-04:00PM">03:00-04:00PM</option>
                <option value="04:00-05:00PM">04:00-05:00PM</option>
                <option value="05:00-06:00PM">05:00-06:00PM</option>
                <option value="06:00-07:00PM">06:00-07:00PM</option>
                <option value="07:00-08:00PM">07:00-08:00PM</option>
                <option value="08:00-09:00PM">08:00-09:00PM</option>
                <option value="09:00-10:00PM">09:00-10:00PM</option>
              </select>
            </div>
          </div>
          <FA
            name="arrow-right"
            onClick={e => this.handleSubmit(e)}
            className="iconNext"
          />
        </ValidatorForm>
        <ToastContainer transition={Flip} />
      </div>
    );
  }
}

const mapStateToProps = State => {
  return { user: State.bookSession, service: State.serviceState };
};

const mapDispatchToProps = dispatch => {
  return {
    onAddPost: (service_time, typeOfservice, trial_date, user_category, trial_time) => {
      dispatch(userBooking({ service_time, typeOfservice, trial_date, user_category, trial_time }));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PickServiceTime);